import { PowerPriceState, PowerPriceStateType } from '../dto'

export interface ManualTariffOptionState {
  /* whether the manual option is offered in the tariff-type toggle */
  showManualOption: boolean
  /* whether the manual option is present but not selectable (feature off, existing config only) */
  isManualOptionDisabled: boolean
}

/**
 * Resolve how the manual tariff option should behave in the tariff-type toggle.
 *
 * - feature enabled: option shown and selectable.
 * - feature disabled but a manual tariff is already configured: option shown but disabled, so the
 *   user can still switch away from it.
 * - feature disabled and no manual tariff configured: option hidden.
 */
export const resolveManualTariffOptionState = (isManualTariffEnabled: boolean, hasExistingManualConfig: boolean): ManualTariffOptionState => ({
  showManualOption: isManualTariffEnabled || hasExistingManualConfig,
  isManualOptionDisabled: !isManualTariffEnabled,
})

/**
 * Whether the manual configuration box should be shown as disabled with a "temporarily not
 * available" hint. This happens when the current selection is manual but the feature is disabled.
 */
export const isManualTariffTemporarilyUnavailable = (powerPriceState: PowerPriceStateType, isManualTariffEnabled: boolean): boolean => {
  return powerPriceState === PowerPriceState.Manual && !isManualTariffEnabled
}
